/* src/app/private/components/view/orgnaization-config/create-organization-config/create-organization-config.component.scss */
label {
  font-size: 14px;
  font-weight: 500;
  color: #000000;
  margin-bottom: 5px;
}
/*# sourceMappingURL=create-organization-config.component.css.map */
